import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9b230ce8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "panel-wrapper"
};
const _hoisted_2 = {
  class: "panel-title"
};
export default {
  name: 'PanelWrapper',
  props: {
    title: {
      type: String,
      default: ''
    }
  },

  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1), _renderSlot(_ctx.$slots, "default")]);
    };
  }

};